import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import _isEqual from 'lodash/isEqual';

import LoaderBar from 'components/LoaderBar';
import DashboardContainer from 'components/DashboardContainer';
import SearchWithFilters from 'components/SearchWithFilters';
import IntegrationTable from './IntegrationTable';

import { usePrevious } from 'hooks';
import { integrationsTable as TEXT } from 'locales/en/integration';
import {
  integrationAllSelector,
  setParams,
  getIntegrations,
  searchIntegrations,
  setSearchTerm,
} from 'redux/slices/integration';

const Integrations = () => {
  const dispatch = useDispatch();
  const { data, params, pagination, isLoading, searchTerm } = useSelector(
    (state) => integrationAllSelector(state)
  );
  const company = useSelector((state) => state.company.current);
  const prevCompany = usePrevious(company);
  const prevParams = usePrevious(params);

  useEffect(() => {
    dispatch(getIntegrations());

    return () => {
      dispatch(setSearchTerm(''));
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (prevCompany !== null && prevCompany !== company) {
      dispatch(
        setParams({
          page: 1,
        })
      );
      dispatch(getIntegrations());
    }
  }, [company, dispatch, prevCompany]);

  useEffect(() => {
    if (prevParams !== null && !_isEqual(params, prevParams)) {
      dispatch(getIntegrations());
    }
  }, [dispatch, params, prevParams]);

  const onChangePerPage = (per_page) => {
    dispatch(
      setParams({
        per_page,
        page: 1,
      })
    );
  };

  const onChangePage = ({ selected }) => {
    dispatch(
      setParams({
        page: selected + 1,
      })
    );
  };

  const onChangeSearchTerm = (event) => {
    dispatch(setSearchTerm(event.target.value || ''));
  };

  const onClearInput = () => {
    dispatch(setSearchTerm(''));
    dispatch(getIntegrations());
  };

  const onSearch = () => dispatch(searchIntegrations());

  return (
    <DashboardContainer header={TEXT.header}>
      <LoaderBar isVisible={isLoading} />
      <SearchWithFilters
        onChangeInput={onChangeSearchTerm}
        searchTerm={searchTerm}
        onSearch={onSearch}
        placeholder={TEXT.search}
        onClearInput={onClearInput}
      />
      <IntegrationTable
        data={data}
        pagination={pagination}
        onClickPerPage={onChangePerPage}
        onPageChange={onChangePage}
      />
    </DashboardContainer>
  );
};

export default Integrations;
